import {
  BuildChipListItemOptions,
  ChipConfig,
  ChipListItem,
  ResolvedChipConfig,
  WithLockedPreservedParams,
} from './chipList.types';

export const resolveChipConfig = (config?: ChipConfig): ResolvedChipConfig => ({
  isDeletable: config?.isDeletable ?? true,
  tooltip: config?.tooltip,
  onClick: config?.onClick,
  label: config?.label,
  className: config?.className,
});

export const buildChipListItem = (
  config: ResolvedChipConfig,
  { key, fallbackLabel, onDelete, className, disabled }: BuildChipListItemOptions,
): ChipListItem => ({
  key,
  label: config.label ?? fallbackLabel,
  onDelete: config.isDeletable ? onDelete : undefined,
  onClick: config.onClick,
  tooltip: config.tooltip,
  disabled,
  className: [className, config.className].filter(Boolean).join(' ') || undefined,
});

export const withLockedPreserved = <T>({
  current,
  next,
  isLocked,
  isEqual = (a, b) => a === b,
}: WithLockedPreservedParams<T>): T[] => {
  const result = [...next];
  let lockedPreservedCount = 0;

  current.forEach((item) => {
    if (!isLocked(item)) {
      return;
    }

    const isPreserved = result.some((selected) => isEqual(selected, item));

    if (!isPreserved) {
      result.splice(lockedPreservedCount, 0, item);
    }

    lockedPreservedCount += 1;
  });

  return result;
};
